/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { User } from './User';
const PlagiarismCaseSubmissionParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['assignmentId', codecNumber, 'assignment_id'],
    ['user', User],
    ['createdAt', parsers.moment, 'created_at'],
]);
export class PlagiarismCaseSubmission extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PlagiarismCaseSubmissionParser.decode(input).map(res => new PlagiarismCaseSubmission(res));
    }
    static unsafeDecode(input) {
        return PlagiarismCaseSubmission.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PlagiarismCaseSubmissionParser.encode(data);
    }
    static schema() {
        return PlagiarismCaseSubmissionParser.schema();
    }
}
